/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/metadata/dataTransfer/resolvers/default/link/task"/>
import {unpack} from "Core/Medius.Core.Web/Scripts/Medius/knockout/utils";
import * as typeBoundResolverFactory from "Core/Medius.Core.Web/Scripts/Medius/core/metadata/dataTransfer/resolvers/typeBound";
import * as path from "Core/Medius.Core.Web/Scripts/Medius/lib/path";
import { getEmbeddableUrlIfNeeded } from "Core/Medius.Core.Web/Scripts/Bifrost/embedding";

export const resolver = typeBoundResolverFactory.create({
    priority: typeBoundResolverFactory.priority.lowest,
    type: "Medius.Data.Task",
    resolve: function (data: any) {
        const entityId = unpack(data.Id);
        const prefix = getEmbeddableUrlIfNeeded("#Tasks"); 

        return {
            link: path.getBasePath() + [prefix, entityId].join("/")
        };
    }
});
